import { __decorate } from "tslib";
import { Pipe } from "@angular/core";
let FilterPipe = class FilterPipe {
    transform(items, filter) {
        if (!items || !filter) {
            return items;
        }
        const key = Object.keys(filter)[0];
        const value = filter[key];
        return items.filter((e) => e[key] == value);
    }
};
FilterPipe = __decorate([
    Pipe({
        standalone: false,
        name: "filter"
    })
], FilterPipe);
export { FilterPipe };
